import { OnInit, Component } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { RateBoardService } from '../../services/rateboard.service';
import { MatDialog } from '@angular/material/dialog';
import moment from 'moment-timezone';
@Component({
    selector: 'modern-theme-foreign-exchange',
    templateUrl: './foreign-exchange.component.html'
})
export class ForeignExchangeComponent implements OnInit {
    data: any;
    asOfDate: string='';
    universalSymbol: string ='';
    timeZone:string='America/New_York';
    constructor(
        private translationService: PershingTranslationService,
        private rateBoardService: RateBoardService,
        private dialog: MatDialog ) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-rateboard', 'node_modules/@pershing/nxi-ng-rateboard/lib');
    }
    ngOnInit() {
        this.rateBoardService.getForeignExchangeData().subscribe(resp => {
            if( resp.response && resp.response.length > 0){
                this.data = resp.response;
                this.asOfDate = moment(this.data[0].asOfDate).tz(this.timeZone).format("MMM DD, YYYY");
            }
        });
    }
    closeDialog() {
        this.dialog.closeAll();
    }

}